// Define the sets of variant IDs and corresponding URLs
const effectiveKitAndMysteryGift = [42115765534876, 42101151957148]
const completeKitAndMysteryGift = [42335359729820, 42101151957148]
const ultimateKitAndMysteryGift = [42472089321628, 42101151957148]
const effectiveKit = [42115765534876]
const completeKit = [42335359729820]
const ultimateKit = [42472089321628]

const effectiveKitCheckoutUrl = 'https://order.uprootclean.com/direct/checkout-effective-kit?discount='
const completeKitCheckoutUrl = 'https://order.uprootclean.com/direct/checkout-complete-home-kit?discount='
const ultimateKitCheckoutUrl = 'https://order.uprootclean.com/direct/checkout-ultimate-bundle?discount='
const defaultCheckoutUrl = '/checkout'

var igGroupIsControl

// Function to check if two arrays are equal (order doesn't matter)
function arraysMatch(arr1, arr2) {
  if (arr1.length !== arr2.length) return false
  const sortedArr1 = [...arr1].sort()
  const sortedArr2 = [...arr2].sort()
  return sortedArr1.every((value, index) => value === sortedArr2[index])
}

// Function to get the matching checkout URL based on the cart contents
function getCheckoutUrl(cartItems, discountCode) {
  const cartVariantIds = cartItems.map((item) => item.variant_id)
  console.log('cartVariantIds', cartVariantIds)
  console.log('cartsMatch', arraysMatch(cartVariantIds, effectiveKitAndMysteryGift))
  if (arraysMatch(cartVariantIds, effectiveKitAndMysteryGift) || arraysMatch(cartVariantIds, effectiveKit)) {
    window.igEvents.push({ event: 'inFunnelishTest' })
    const finalVariantUrl = discountCode ? effectiveKitCheckoutUrl + discountCode : effectiveKitCheckoutUrl
    return igGroupIsControl ? defaultCheckoutUrl : finalVariantUrl
  } else if (arraysMatch(cartVariantIds, completeKitAndMysteryGift) || arraysMatch(cartVariantIds, completeKit)) {
    window.igEvents.push({ event: 'inFunnelishTest' })
    const finalVariantUrl = discountCode ? completeKitCheckoutUrl + discountCode : completeKitCheckoutUrl
    return igGroupIsControl ? defaultCheckoutUrl : finalVariantUrl
  } else if (arraysMatch(cartVariantIds, ultimateKitAndMysteryGift) || arraysMatch(cartVariantIds, ultimateKit)) {
    window.igEvents.push({ event: 'inFunnelishTest' })
    const finalVariantUrl = discountCode ? ultimateKitCheckoutUrl + discountCode : ultimateKitCheckoutUrl
    return igGroupIsControl ? defaultCheckoutUrl : finalVariantUrl
  } else {
    return defaultCheckoutUrl // No match
  }
}

function getDiscountCodes(cartItems) {
  const discountCodes = []
  for (const item of cartItems) {
    if (item?.discounts && item.discounts.length > 0) {
      for (const discount of item.discounts) {
        discountCodes.push(discount.title)
      }
    }
  }
  return discountCodes.length > 0 ? discountCodes[0] : null
}

function hasQuantityGreaterThanTwo(cartItems) {
  return cartItems.some((cartItem) => cartItem.quantity > 1)
}

// Function to handle checkout button click
function handleCheckoutButtonClick() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const cartItems = cart.items

      if (hasQuantityGreaterThanTwo(cartItems)) {
        window.location.href = defaultCheckoutUrl
      } else {
        const discountCode = getDiscountCodes(cartItems)
        const checkoutUrl = getCheckoutUrl(cartItems, discountCode)
        if (checkoutUrl) {
          // Cart matches one of the sets, redirect to the corresponding URL
          window.location.href = checkoutUrl
        } else {
          // Cart does not match, show an alert or handle accordingly
          console.error('Your cart must contain one of the specific kits with a mystery gift.')
          window.location.href = defaultCheckoutUrl
        }
      }
    })
    .catch((error) => {
      console.error('Error checking cart contents:', error)
      // Handle the error (e.g., show an error message to the user)
      window.location.href = defaultCheckoutUrl
    })
}

window.addEventListener('ig:ready', () => {
  igGroupIsControl = window.igData?.user?.getTestGroup('2b75dc66-3105-40bb-af40-50bbb96f7bbc')?.isControl
  console.log('igGroupIsControl', igGroupIsControl)
})
